import tw from '@/common/utils/twmacro';

export const SectionContainer = tw.div`flex flex-col gap-4 border border-border rounded-md p-4`;
export const SectionHeader = tw.div`flex flex-col`;
export const SectionContent = tw.div`flex flex-col gap-4`;
